// Rendu Markdown léger, sans dépendance externe.
// Gère : blocs de code ```, titres #/##/###, listes -, **gras**, `code inline`.
import { Fragment } from "react";

function renderInline(text) {
  // découpe sur **gras** et `code`
  const parts = text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g);
  return parts.map((p, i) => {
    if (/^\*\*[^*]+\*\*$/.test(p)) {
      return <strong key={i} className="font-semibold text-foreground">{p.slice(2, -2)}</strong>;
    }
    if (/^`[^`]+`$/.test(p)) {
      return <code key={i} className="px-1.5 py-0.5 rounded bg-[#1a1a1a] text-primary font-mono text-[0.85em]">{p.slice(1, -1)}</code>;
    }
    return <Fragment key={i}>{p}</Fragment>;
  });
}

export default function MarkdownLite({ content }) {
  if (!content) return null;
  const lines = content.replace(/\r\n/g, "\n").split("\n");
  const blocks = [];
  let i = 0;
  let listBuffer = [];

  const flushList = () => {
    if (listBuffer.length) {
      blocks.push(
        <ul key={`ul-${blocks.length}`} className="list-disc pl-5 space-y-1 my-2 text-muted-foreground">
          {listBuffer.map((item, k) => <li key={k}>{renderInline(item)}</li>)}
        </ul>
      );
      listBuffer = [];
    }
  };

  while (i < lines.length) {
    const line = lines[i];

    // Bloc de code ```
    if (line.trim().startsWith("```")) {
      flushList();
      const codeLines = [];
      i++;
      while (i < lines.length && !lines[i].trim().startsWith("```")) {
        codeLines.push(lines[i]);
        i++;
      }
      i++; // saute le ``` fermant
      blocks.push(
        <pre key={`code-${blocks.length}`} className="my-3 p-3 rounded-lg bg-[#141414] border border-[#222] overflow-x-auto">
          <code className="font-mono text-[13px] text-green-300 whitespace-pre">{codeLines.join("\n")}</code>
        </pre>
      );
      continue;
    }

    // Titres
    const h = line.match(/^(#{1,3})\s+(.*)$/);
    if (h) {
      flushList();
      const level = h[1].length;
      const cls = level === 1 ? "text-lg font-bold mt-4 mb-2" : level === 2 ? "text-base font-bold mt-4 mb-2" : "text-sm font-semibold mt-3 mb-1";
      blocks.push(<div key={`h-${blocks.length}`} className={cls}>{renderInline(h[2])}</div>);
      i++;
      continue;
    }

    // Listes à puces
    const li = line.match(/^\s*[-*]\s+(.*)$/);
    if (li) {
      listBuffer.push(li[1]);
      i++;
      continue;
    }

    // Ligne vide
    if (line.trim() === "") {
      flushList();
      i++;
      continue;
    }

    // Paragraphe
    flushList();
    blocks.push(<p key={`p-${blocks.length}`} className="my-2 text-muted-foreground leading-relaxed">{renderInline(line)}</p>);
    i++;
  }
  flushList();

  return <div className="text-sm">{blocks}</div>;
}
